import HttpCLient from '@/src/lib/utils/httpClient';
import { ApiRouts } from '@/src/routes/routes';
import { FormDTO } from '@/src/components/join-us/join-us';
import { Iindustries } from '@/src/types/industries';

type City = {
  id: string;
  englishName: string;
  arabicName: string;
};

type TActiveCountry = {
  arabicCountryName: string;
  englishCountryName: string;
  currencyCode: string;
  id: number;
};
// export type JoinUsParams = {
//   JoinUsData: ;
// };

class JoinUsApi extends HttpCLient {
  async getActiveCountries() {
    const params = {
      page: '1',
      pageCount: '40',
    };
    const data = await this.get<TActiveCountry[]>(ApiRouts.getAllActiveCountries, params);
    return data;
  }

  async getCitiesByCountry(countryId: string) {
    const params = {
      page: '1',
      pageCount: '40',
      countryId: countryId,
    };
    const data: City[] = await this.get(ApiRouts.getCitiesByCountry, params);
    return data;
  }

  async getCitiesData() {
    try {
      const data: City[] = await this.get(ApiRouts.cities);
      return data;
    } catch (error) {}
  }

  async getIndustries() {
    try {
      const data: Iindustries[] = await this.get(ApiRouts.industries);
      return data;
    } catch (error) {}
  }

  submitJoinUs = async (JoinUsData: FormDTO) => {
    return this.post<FormDTO>('stores/onboarding', JoinUsData);
  };
}

export const joinUsApi = new JoinUsApi();
